declare const bootstrap: any;

import { Component, ElementRef, Input, ViewChild } from '@angular/core';

import { AssetData } from '../../../models/assetData.model';
import { DashboardService } from '../../../services/dashboard.service';
import { SubstationTemplateStat } from '../../../models/substation-template-stat.model';

@Component({
  selector: 'lib-analytics-overview',
  standalone: false,
  templateUrl: './analytics-overview.component.html',
  styleUrl: './analytics-overview.component.scss',
})
export class AnalyticsOverviewComponent {
  constructor(private dashboardService: DashboardService) {}
  @Input() areaIds: number[] = [];
  @Input() poleData: AssetData = new AssetData();
  @Input() customersData: AssetData = new AssetData();
  @Input() buildingsData: AssetData = new AssetData();
  @Input() distributionSubstationsData: AssetData = new AssetData();
  @Input() tsData: AssetData = new AssetData();
  @Input() substationData: AssetData = new AssetData();
  @Input() devicesData: AssetData = new AssetData();
  @Input() sectionDefinitionData: AssetData = new AssetData();
  @Input() f11Data: AssetData = new AssetData();
  @Input() f33Data: AssetData = new AssetData();
  @Input() feedersData: AssetData = new AssetData();
  @Input() cimFeedersData: AssetData = new AssetData();
  @Input() mainFeederData: AssetData = new AssetData();
  @Input() primaryFeederData: AssetData = new AssetData();
  @Input() secondaryFeederData: AssetData = new AssetData();
  @Input() hasCimDataIntegration: boolean = false;
  @Input() substationTemplateStats: SubstationTemplateStat[] = [];
  @Input() equipmentData: AssetData = new AssetData();
  mvPoleData: AssetData = new AssetData();
  hvPoleData: AssetData = new AssetData();
  lvPoleData: AssetData = new AssetData();
  // networkStructureData: AssetData = new AssetData();

  @ViewChild('detailsModal', { static: true }) detailsModalRef!: ElementRef;
  selectedDetailsType: 'pole' | 'feeder' | 'network-structure' | null = null;

  // The feeder overview/breakdown switches between the legacy (f11/f33) objects and the
  // CIM (main/primary/secondary) objects based on hasCimDataIntegration.
  get feedersOverviewData(): AssetData {
    return this.hasCimDataIntegration ? this.cimFeedersData : this.feedersData;
  }

  get mainFeederDisplay(): AssetData {
    return this.hasCimDataIntegration ? this.mainFeederData : this.f33Data;
  }

  get devicesOverviewData(): AssetData {
    return this.hasCimDataIntegration ? this.equipmentData : this.distributionSubstationsData;
  }

  get primaryFeederDisplay(): AssetData {
    return this.hasCimDataIntegration ? this.primaryFeederData : this.f11Data;
  }

   get feederSum(): number {
    return (this.primaryFeederDisplay?.totalCount || 0) + (this.mainFeederDisplay?.totalCount || 0)
      + (this.hasCimDataIntegration ? (this.secondaryFeederData?.totalCount || 0) : 0);
  }

  get networkStructureSum(): number {
    return (this.distributionSubstationsData?.totalCount || 0) + (this.substationData?.totalCount || 0) + (this.tsData?.totalCount || 0);
  }

  get poleSum(): number {
    return (
      this.poleData?.items?.reduce((sum, item) => sum + item.value, 0) ?? 0
    );
  }

  get networkStructureData(): AssetData {
    return new AssetData({
      assetName: 'Network Structure',
      totalCount: this.networkStructureSum,
      previousMonthTotal:
        (this.distributionSubstationsData?.previousMonthTotal || 0) +
        (this.substationData?.previousMonthTotal || 0) +
        (this.tsData?.previousMonthTotal || 0),
      countIncrease:
        (this.distributionSubstationsData?.countIncrease || 0) +
        (this.substationData?.countIncrease || 0) +
        (this.tsData?.countIncrease || 0),
    });
  }

  openDetailsModal(type: 'pole' | 'feeder' | 'network-structure') {
    this.selectedDetailsType = type;
    var obj = { areaIds: this.areaIds };

    if (type === 'pole') {
      this.dashboardService.getAnalyticsOverviewMvPole(obj).subscribe({
        next: (data) => {
          this.mvPoleData = new AssetData(data?.body?.data, 'MvPole');
        },
        error: (error) => console.log(error.statusText),
      });
      this.dashboardService.getAnalyticsOverviewLvPole(obj).subscribe({
        next: (data) => {
          this.lvPoleData = new AssetData(data?.body?.data, 'MvPole');
        },
        error: (error) => console.log(error.statusText),
      });
    }
    else {
    }
    const modalElement = document.getElementById('exampleModalCenter');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
    }
  }
}
